import {
  InfiniteScroll,
  Loading,
} from '@trufla-technology/trumarket-react-design-system';
import { useListProductDefinitions } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { useLocation } from 'react-router-dom';
import { ProductCard } from './product-card';
import './style.scss';
import { useEffect, useState } from 'react';
import { ListActivitiesResponse } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { GetProductDefinitionByKey } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';

type Product = GetProductDefinitionByKey;

export const CompanyProducts = () => {
  const { data, handleOffset, paging, query, loading } =
    useListProductDefinitions({
      paginate: {
        limit: 20,
        offset: 0,
      },
      select: ['key', 'name', 'createdAt'],
    });
  const location = useLocation<{ productKey: string }>();

  const [products, setProducts] = useState<ListActivitiesResponse['data']>([]);

  useEffect(() => {
    if (!data) return;
    setProducts([...products!, ...data!]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const loadMore = () => {
    handleOffset(query.paginate?.limit! + query.paginate?.offset!);
  };
  return (
    <div className="products-page">
      <h4>Products</h4>
      <InfiniteScroll
        height="70vh"
        data={products!}
        itemContent={(index: number, product: Product) => {
          return (
            <ProductCard
              product={product}
              key={product.key}
              shouldUpdate={product.key === location?.state?.productKey}
            />
          );
        }}
        loadMore={loadMore}
        hasMore={!!!(products?.length! >= paging?.count!)}
        emptyPlaceHolder={
          products?.length! <= 0 && !loading ? (
            <div className="no-activities">No Products</div>
          ) : null
        }
      />
      {loading && (
        <div className="infinite-loading">
          <Loading />
        </div>
      )}
    </div>
  );
};
